import React, {useState} from 'react';
import type {SignalDescription} from '../types';

export const SignalDescriptionBlock: React.FC<{ description: SignalDescription }> = ({description}) => {
    const [expanded, setExpanded] = useState(false);
    return (
        <div className={`pc-desc${expanded ? ' expanded' : ' collapsed'}`}>
            <div className="pc-desc-content">
                <div>{description.definition}</div>
                <div style={{marginTop: 4, fontSize: 10}}>意义 {description.meaning}</div>
                <div style={{marginTop: 4, fontSize: 10}}>
                    <span style={{color: 'var(--pt-bull)'}}>确认</span> {description.confirmation}
                </div>
                <div style={{fontSize: 10}}>
                    <span style={{color: 'var(--pt-bear)'}}>失效</span> {description.invalidation}
                </div>
                <div style={{fontSize: 10}}>风险 {description.riskTip}</div>
            </div>
            <button
                type="button"
                className="pc-desc-toggle"
                aria-expanded={expanded}
                onClick={(event) => {
                    event.stopPropagation();
                    setExpanded(value => !value);
                }}
            >
                {expanded ? '收起说明' : '展开说明'}
            </button>
        </div>
    );
};
